// extracted by mini-css-extract-plugin
module.exports = {"powerstream-cooperation-A":"A_powerstream-cooperation-A__Fl4q_"};